import { render, staticRenderFns } from "./pig-info.vue?vue&type=template&id=43a0db4d&scoped=true"
import script from "./pig-info.vue?vue&type=script&lang=js"
export * from "./pig-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a0db4d",
  null
  
)

export default component.exports